import {
  Flower2, Flower, Gem, Heart, Star, Sun, Leaf, Gift,
  Crown, Sparkles, Droplets, Scissors, Award, Feather, Snowflake,
} from "lucide-react";

// Task 10 (C11) — admin-selectable icon library for variety qualities.
// Keys must match ALLOWED_ICONS in the backend.
export const ICON_LIBRARY = [
  { key: "vase", label: "Vase", Icon: Flower2 },
  { key: "bouquet", label: "Bouquet", Icon: Flower },
  { key: "wedding", label: "Wedding", Icon: Gem },
  { key: "heart", label: "Heart", Icon: Heart },
  { key: "star", label: "Star", Icon: Star },
  { key: "sun", label: "Sun", Icon: Sun },
  { key: "leaf", label: "Leaf", Icon: Leaf },
  { key: "gift", label: "Gift", Icon: Gift },
  { key: "crown", label: "Crown", Icon: Crown },
  { key: "sparkles", label: "Sparkles", Icon: Sparkles },
  { key: "droplet", label: "Droplet", Icon: Droplets },
  { key: "scissors", label: "Scissors", Icon: Scissors },
  { key: "award", label: "Award", Icon: Award },
  { key: "feather", label: "Feather", Icon: Feather },
  { key: "snowflake", label: "Snowflake", Icon: Snowflake },
];

export function iconFor(key) {
  return (ICON_LIBRARY.find((i) => i.key === key) || ICON_LIBRARY[3]).Icon;
}
